import React from "react";
import { Link } from "react-router-dom";
import { Heart, Trash2 } from "lucide-react";
import { useShop } from "../context/ShopContext";
import { formatINR } from "../lib/api";

export default function Wishlist() {
  const { wishlist, toggleWishlist, addToCart } = useShop();

  return (
    <div data-testid="wishlist-page" className="min-h-screen max-w-7xl mx-auto px-6 lg:px-10 py-16">
      <div className="overline mb-3">Saved</div>
      <h1 className="section-title text-4xl sm:text-5xl mb-10">Your Wishlist</h1>

      {wishlist.length === 0 ? (
        <div className="border border-white/10 py-20 text-center">
          <Heart className="mx-auto text-white/30" size={40} />
          <p className="mt-4 text-white/60 font-body">Nothing saved yet.</p>
          <Link to="/shop" className="btn-orange mt-6 inline-flex">Discover Products</Link>
        </div>
      ) : (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-5">
          {wishlist.map((w) => (
            <div key={w.product_id} data-testid={`wish-item-${w.slug}`} className="card-product">
              <Link to={`/product/${w.slug}`}>
                <div className="aspect-[4/5] overflow-hidden bg-[#0e0e0e]">
                  <img src={w.image} alt={w.name} className="w-full h-full object-cover" />
                </div>
              </Link>
              <div className="p-4">
                <Link to={`/product/${w.slug}`}>
                  <h3 className="font-display uppercase text-sm tracking-tight line-clamp-2">{w.name}</h3>
                </Link>
                <div className="font-display text-lg mt-1.5">{formatINR(w.price)}</div>
                <div className="flex gap-2 mt-3">
                  <button
                    onClick={() => addToCart({ id: w.product_id, slug: w.slug, name: w.name, images: [w.image], price: w.price })}
                    className="flex-1 bg-[#D96A1B] hover:bg-[#E87A2A] text-white text-[10px] font-display tracking-widest uppercase py-2.5"
                  >Add To Cart</button>
                  <button onClick={() => toggleWishlist({ id: w.product_id, name: w.name, slug: w.slug })} className="p-2 text-white/50 hover:text-[#D96A1B]"><Trash2 size={14} /></button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
